<script setup>

import { Icon, Modal, Button } from '@components'

import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

const props = defineProps({
    title: {
        type: String
    },
    progress: {
        type: Number,
        default: 0
    },
    backButton: {
        type: Function,
    }
})

// const emit = defineEmits(['back'])

const backButton = () => {
    // if no props button then function then manually go back
    if (!props.backButton) {
        router.back()
        return
    }

    props.backButton()
}

const nextButton = () => {
    // router.push({ name: 'dashboard' })
}

const pageTitle = () => {
    return route.meta.title || ''
}
</script>

<template>
    <Modal :key="Math.random()" class="z-[100]" :progress="props.progress" progressClass="!h-[6px] !bottom-0 rounded-r-[10px]" footerClass="h-[110px] border-t-[#EAECF0] border-t" contentClass="h-[calc(100vh-206px)] !w-[729px] m-auto !px-[50px] !pt-[69px]">

        <template #header>
            <div class="py-8 px-[22px] border-b-[#EAECF0] border-b-[6px] flex items-center justify-between">
                <div @click="backButton" class="cursor-pointer flex items-center gap-[22px] text-[#101828] text-lg font-semibold">
                    <Icon class="text-[#667085]" name="arrowNarrowLeft" size="24px"></Icon> Back
                </div>
            </div>
        </template>

        <template #default>
            <div class="font-semibold text-[24px] mb-[42px] text-center" v-if="props.title">{{ props.title }}</div>
            <slot></slot>
        </template>

        <template #footer>
            <div class="flex items-center gap-10 mt-6 mb-[42px] m-auto max-w-[629px]">
                <slot name="footer"></slot>
            </div>
        </template>

    </Modal>
</template>


<style>

</style>